<template>
    <tr v-if="property === 'minWidth'">
        <td class="editor-content editor-label">Min Width</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="number" v-model="selectedComponent.style.minWidth"/>
        </td>
    </tr>
    <tr v-else-if="property === 'maxWidth'">
        <td class="editor-content editor-label">Max Width</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="number" v-model="selectedComponent.style.maxWidth"/>
        </td>
    </tr>
    <tr v-else-if="property === 'minHeight'">
        <td class="editor-content editor-label">Min Height</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="number" v-model="selectedComponent.style.minHeight"/>
        </td>
    </tr>
    <tr v-else-if="property === 'maxHeight'">
        <td class="editor-content editor-label">Max Height</td>
        <td class="editor-content">
            <input class="form-control editor-form" type="number" v-model="selectedComponent.style.maxHeight"/>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'MinMaxWidthHeightEditor',
        props: ['selectedComponent', 'property'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

